import React from 'react';
import Reflux from 'reflux';
import {
    Button,
    message,
    Modal,
    Select,
    Popconfirm,
    Input,
    Tooltip,
    Radio,
    DatePicker
} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {
    detail,
    getRegister,
    getCancelLine,
    rejectOrder,
    submitOrder,
    getShipLine,
    getDelLine,
    getShipAll
} from '../../service/thingsOrder';
import {getDealerList} from '../../service/dealer';
import {config} from 'Utils';
import moment from 'moment';
import {detail2} from "../../service/channel";

const {RangePicker} = DatePicker;
const RadioGroup = Radio.Group;
const deliveryTypeMap = {
    '1': '快递',
    '2': '上门自提'
}; // 1：快递；2：上门自提
class ThingsOrder extends Reflux.Component {
    constructor(props) {
        super(props);
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.state = {
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            opts: ['查看销售单'],
            showHideBtnIndex: '',
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: [],
            total: 1,
            searchObj: {
                name: '',
                category: [],
                active: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            value: '',
            visible: false,
            url: '',
            distributorList: [],
            selectedDistributor: {},
            defaultDistributor: '',
            phone: '',
            confirmvisible: false,
            confirmLoading: false,
            confirmvisible2: false,
            confirmLoading2: false,
            confirmvisible3: false,
            confirmLoading3: false,
            titleCount: '数量',
            titleShip: '数量',
            titleButton: '整单',
            noShip: true,
            printType: 1,
            startDate: '',
            endDate: '',
            amountDecimalPlace: JSON.parse(window.localStorage.getItem('login_user_information')).amountDecimalPlace != null ? JSON.parse(window.localStorage.getItem('login_user_information')).amountDecimalPlace : 2,
            priceDecimalPlace: JSON.parse(window.localStorage.getItem('login_user_information')).priceDecimalPlace != null ? JSON.parse(window.localStorage.getItem('login_user_information')).priceDecimalPlace : 4,
            countDecimalPlace: JSON.parse(window.localStorage.getItem('login_user_information')).countDecimalPlace != null ? JSON.parse(window.localStorage.getItem('login_user_information')).countDecimalPlace : 2

        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
        this.cancelLine = this.cancelLine.bind(this);
        this.shipLine = this.shipLine.bind(this);
        this.delLine = this.delLine.bind(this);
        this.onOk = this.onOk.bind(this);
    };

    goBack() {
        hashHistory.push('/thingsOrder');
    }

    /*路径跳转*/
    goView(url) {
        getDealerList({s: 1000, p: 1,}).then(res => {
            if (res.code === 200) {
                this.setState({
                    distributorList: res.data
                }, () => {
                    if (res.data.length == 1) {
                        this.handleChange(res.data[0].id)
                    }
                });
            }
        });
        this.setState({
            visible: true,
            url
        });
    };

    handleOK() {
        const {url} = this.state;
        this.setState({
            visible: false
        });
        window.open(`/pcweb/#${url}`);
        // window.open(`/#${url}`);
    }

    handleCancel() {
        this.setState({
            visible: false,
            url: ''
        });
    }

    edit() {
        const id = this.props.params.id;
        hashHistory.push(`/thingsOrder/edit/${id}`);
    }

    handleChange(value) {
        const {distributorList} = this.state;
        const obj = distributorList.filter(item => item.id === ~~value)[0];
        this.setState({
            selectedDistributor: obj,
            defaultDistributor: obj.companyName
        });
        window.sessionStorage.setItem('distributor', JSON.stringify(obj));
    }

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let id = this.props.params.id;
        let allCount = 0;
        detail(id).then(result => {
            if (result.status) {
                const productList = result.data.productList || [];
                productList.forEach((item, index) => {
                    item.key = index;
                    allCount = allCount + item.count;
                    if (item.shipCount > 0) {
                        this.setState({noShip: false});
                    }
                    for (let i = 0; i < productList.length; i++) {
                        productList[i].rownum = i + 1;
                        productList[i].discountMoney = productList[i].unitPrice * productList[i].count;
                    }
                });
                if (allCount == 0) {
                    this.setState({noShip: false});
                }
                detail2(result.data.cusId).then(res => {
                    if (res.status && res.data) {
                        result.data.phone = res.data.phone;
                        result.data.cusaddress = res.data.address;
                        window.sessionStorage.setItem('mianjiaprint', JSON.stringify(result.data));
                        window.sessionStorage.setItem('ordinaryprint', JSON.stringify(result.data));
                        window.sessionStorage.setItem('buhanmianjiaprint', JSON.stringify(result.data));
                        window.sessionStorage.setItem('receiptprint', JSON.stringify(result.data));
                        window.sessionStorage.setItem('amountDecimalPlace', this.state.amountDecimalPlace);
                        window.sessionStorage.setItem('priceDecimalPlace', this.state.priceDecimalPlace);
                        window.sessionStorage.setItem('countDecimalPlace', this.state.countDecimalPlace);
                    } else {
                        message.error("二级客户获取失败！");
                    }
                });
                this.setState({
                    resultData: [result.data],
                    rows: productList,
                    titleCount: result.data.orderType == 3 ? '退单数量' : '订单数量',
                    titleShip: result.data.orderType == 3 ? '入库数量' : '出库数量',
                    titleButton: result.data.orderType == 3 ? '整单入库' : '整单出库'
                });
            } else {
                message.error(result.message);
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    register = () => {
        let id = this.props.params.id;
        let self = this;
        self.setState({confirmLoading: true});
        getRegister(id).then((result) => {
            if (result.status) {
                message.success(result.message);
                self.setState({confirmvisible: false, confirmLoading: false});
                self.initData();
            } else {
                message.error(result.message);
                self.setState({confirmvisible: false, confirmLoading: false});
            }
        })
    }

    shipAll = () => {
        let id = this.props.params.id;
        let self = this;
        self.setState({confirmLoading2: true});
        getShipAll(id).then((result) => {
            if (result.status) {
                message.success(result.message);
                self.setState({confirmvisible2: false, confirmLoading2: false});
                self.initData();
            } else {
                message.error(result.message);
                self.setState({confirmvisible2: false, confirmLoading2: false});
            }
        })
    }

    delAll = () => {
        let self = this;
        let id = this.props.params.id;
        let i = 0;
        console.log(self.state.rows.length);
        self.setState({confirmLoading3: true});
        self.state.rows.map(item => {
            if (item.count != 0) {
                getDelLine(id, item.id).then((result) => {
                    i++;
                    if (result.status) {
                        message.success(result.message);
                        if (i == self.state.rows.length) {
                            self.setState({confirmvisible3: false, confirmLoading3: false});
                            self.initData();
                        }
                    } else {
                        message.error(result.message);
                        if (i == self.state.rows.length) {
                            self.setState({confirmvisible3: false, confirmLoading3: false});
                            self.initData();
                        }
                    }
                })
            } else {
                i++;
            }
        });
    }

    cancelLine = (id) => {
        let self = this;
        getCancelLine(id).then((result) => {
            if (result.status) {
                message.success(result.message);
                self.initData();
            } else {
                message.error(result.message);
            }
        })
    }

    shipLine = (orderId, lineid) => {
        let self = this;
        getShipLine(orderId, lineid).then((result) => {
            if (result.status) {
                message.success(result.message);
                self.initData();
            } else {
                message.error(result.message);
            }
        })
    }

    delLine = (orderId, lineid) => {
        let self = this;
        getDelLine(orderId, lineid).then((result) => {
            if (result.status) {
                message.success(result.message);
                self.initData();
            } else {
                message.error(result.message);
            }
        })
    }


    showModal = () => {
        this.setState({
            confirmvisible: true,
        });
    }

    showModal2 = () => {
        this.setState({
            confirmvisible2: true,
        });
    }

    showModal3 = () => {
        this.setState({
            confirmvisible3: true,
        });
    }

    handleCancel3 = () => {
        this.setState({
            confirmvisible: false,
            confirmvisible2: false,
            confirmvisible3: false,
            confirmLoading: false,
            confirmLoading2: false,
            confirmLoading3: false
        });
    }


    /* 导出Excel */
    exportExcel() {
        let _id = this.props.params.id;
        window.location.href = `${config.server}/api/v1/dms/trans/order/exportOrderDetail?id=${_id}`;
    }

    returnFn = () => {
        // this.setState({submitVisible: true})
        // rejectRemark
        rejectOrder({
            "id": this.props.params.id,
            "rejectRemark": this.state.rejectRemark
        }).then(res => {
            this.setState({submitVisible: false})
            !!res.status && this.initData();
            !res.status && message.error(res.message);
        })
    }
    submitFn = () => {
        submitOrder(this.props.params.id).then(res => {
            !!res.status && this.initData();
            !res.status && message.error(res.message);
        })
    }

    printTypeChange = (e) => {
        this.setState({
            printType: e.target.value,
        });
        window.sessionStorage.setItem('printType', e.target.value);
    }

    onChange(value, dateString) {
        console.log('Selected Time: ', value);
        console.log('Formatted Selected Time: ', dateString);
    }

    onOk(value) {
        this.setState({
            startDate: value[0].valueOf(),
            endDate: value[1].valueOf()
        });
        window.sessionStorage.setItem('startDate', value[0].valueOf());
        window.sessionStorage.setItem('endDate', value[1].valueOf());
    }

    render() {
        const {
            opts,
            rows,
            total,
            searchObj,
            resultData,
            button_limits_end,
            visible,
            distributorList,
            confirmLoading,
            confirmvisible,
            confirmLoading2,
            confirmvisible2,
            confirmLoading3,
            confirmvisible3,
            titleCount,
            titleShip,
            noShip,
            titleButton,
            printType, startValue, endValue, endOpen, defaultDistributor
        } = this.state;

        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'rownum'
                },
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 110
                }, {
                    title: '物料描述',
                    dataIndex: 'name'
                },
                {
                    title: '物料类别',
                    dataIndex: 'proType'
                },
                {
                    title: titleCount,
                    dataIndex: 'count'
                },
                {
                    title: '单价',
                    dataIndex: 'unitPrice',
                },
                {
                    title: '销售金额',
                    dataIndex: 'discountMoney',
                    render: (text, record, index) => {
                        return <div>{text.toFixed(this.state.amountDecimalPlace) || 0}</div>
                    }
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '内盒数',
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '现有量/总库存',
                    dataIndex: 'currentNum',
                    render: (text, record, index) => {
                        return <div>{text}/{record.totalNum}</div>
                    }
                }, {
                    title: <Tooltip
                        title='不包含本订单的产品数量，统计【已登记未发货的数量】，同时扣减【已登记未退货入库的数量】。遇到未出库数量不准时，请核查历史【已登记】的订单'>未出库</Tooltip>,
                    dataIndex: 'unShipCount'
                },
                {
                    title: '历史价',
                    dataIndex: 'originalPrice'
                },
                {
                    title: '面价',
                    dataIndex: 'currentPrice',
                    render: (text, record, index) => {
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                },
                {
                    title: '下浮(%)',
                    dataIndex: 'priceRate'
                },

                {
                    title: titleShip,
                    dataIndex: 'shipCount'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '操作',
                    dataIndex: '',
                    render: (text, record, index) => {
                        if ((resultData[0].orderStatus == 1 || resultData[0].orderStatus == 4) && record.count != 0 && record.shipCount != 0 && button_limits_end.thingsOrder_add_07) {
                            return (
                                <div><Popconfirm placement="left" title='您确定要冲销这行吗！' onConfirm={() => {
                                    this.cancelLine(record.id)
                                }}><Button type="danger" size={'small'}>冲销</Button></Popconfirm></div>
                            )
                        } else if (resultData[0].orderStatus == 1 && record.count != 0 && record.shipCount == 0) {
                            return (<div><Popconfirm placement="left" title='您确定要操作这行吗！' onConfirm={() => {
                                    this.shipLine(resultData[0].id, record.id)
                                }}><Button type="primary"
                                           size={'small'}>{resultData[0].orderType == 3 ? '入库' : '出库'}</Button></Popconfirm>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <Popconfirm placement="left" title='您确定要删除这行吗！' onConfirm={() => {
                                        this.delLine(resultData[0].id, record.id)
                                    }}><Button type="danger"
                                               size={'small'}>删除</Button></Popconfirm>
                                </div>
                            )
                        }
                    }
                }
            ],
            rows
        };
        let hasData = false;
        if (resultData.length > 0) {
            hasData = true;
        }
        const orderStatusMap = {
            '-1': '暂存',
            '0': this.userData.second ? '已提交' : '未登记',
            '1': '已登记',
            '2': '驳回',
            '4': '已完成',
            '5': '已冲销'
        }
        const displayData = [
            {label: '订单编号', value: hasData ? resultData[0].code : ''},
            {label: '订单日期', value: hasData ? moment(resultData[0].orderDate).format('YYYY-MM-DD HH:mm:ss') : ''},
            {label: '客户缩写', value: hasData ? resultData[0].cusShortname : ''},
            {label: '客户名称', value: hasData ? resultData[0].cusName : ''},
            {label: '收款方式', value: hasData ? resultData[0].payType : ''},
            {label: '子库存', value: hasData ? resultData[0].storageName : ''},
            {
                label: '订单类型',
                value: hasData ? (resultData[0].orderType == 1 ? '销售单' : (resultData[0].orderType == 2 ? '零售单' : '退货单')) : ''
            },
            {label: '操作员', value: hasData ? resultData[0].operateName : ''},
            {label: '销售员', value: hasData ? resultData[0].businessName : ''},
            {label: '订单状态', value: hasData ? orderStatusMap[resultData[0].orderStatus] : ''},
            {
                label: '驳回原因',
                value: hasData && resultData[0].orderStatus === 2 ? orderStatusMap[resultData[0].rejectRemark] : ''
            },
            {label: '备注', value: hasData ? resultData[0].remark : ''},
            {label: '面价总额', value: hasData ? resultData[0].amount : ''},
            {label: '销售总额', value: hasData ? resultData[0].receivedAmount : ''},
            {label: '订单整体折扣(%)', value: hasData ? resultData[0].discountRate : ''},
            {
                label: '实收总额',
                value: hasData ? (Math.round(resultData[0].receivedAmount * resultData[0].discountRate) / 100).toFixed(this.state.amountDecimalPlace) : ''
            },
            {label: '配送方式', value: hasData ? deliveryTypeMap[resultData[0].deliveryType] || '' : ''},
            {label: '收货人', value: hasData ? resultData[0].linkman : ''},
            {label: '联系方式', value: hasData ? resultData[0].telephone : ''},
            {label: '收货地址', value: hasData ? resultData[0].address : ''},
        ];
        if (!hasData || resultData[0].orderStatus === 2) {
            displayData.splice(9, 1);
        }
        // 订单状态 -1 暂存 0 未登记（已提交） 1 已登记 2 驳回
        return (
            <div className="dms-main-box">
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        {button_limits_end.thingsOrder_add_01 &&
                            <Button style={{marginLeft: 10}} onClick={this.exportExcel.bind(this)}>导出</Button>}
                        {button_limits_end.thingsOrder_add_return && hasData && resultData[0].orderStatus === 0 &&
                            <Button style={{marginLeft: 10}}
                                    onClick={() => this.setState({submitVisible: true})}>驳回</Button>}
                        {button_limits_end.thingsOrder_add_submit && hasData && (resultData[0].orderStatus === -1 || resultData[0].orderStatus === 2) &&
                            <Button style={{marginLeft: 10}} onClick={this.submitFn.bind(this)}>提交</Button>}
                        {/* { button_limits_end.thingsOrder_add_05 &&
            <Button style={{ marginLeft: 10 }} onClick={this.goView.bind(this, '/mianjiaprint/0')}>打印</Button>}*/}
                        {button_limits_end.thingsOrder_add_05 &&

                            //resultData[0].orderStatus ==
                            <Button style={{
                                display: (hasData && (resultData[0].orderStatus == 1 || resultData[0].orderStatus == 4)) ? 'inline-block' : 'none',
                                marginLeft: 10
                            }} onClick={this.goView.bind(this, '/ordinaryprint/1')}>打印</Button>}
                        {button_limits_end.thingsOrder_add_05 &&
                            <Button style={{
                                display: (hasData && (resultData[0].orderStatus == 1 || resultData[0].orderStatus == 4)) ? 'inline-block' : 'none',
                                marginLeft: 10
                            }} onClick={this.goView.bind(this, '/buhanmianjiaprint/1')}>不含面价打印</Button>}
                        {button_limits_end.thingsOrder_add_05 &&
                            <Button style={{
                                display: (hasData && (resultData[0].orderStatus == 1 || resultData[0].orderStatus == 4)) ? 'inline-block' : 'none',
                                marginLeft: 10
                            }} onClick={this.goView.bind(this, '/buhanmianjiaprintA4/1')}>不含面价打印(A4)</Button>}

                        {/* { button_limits_end.thingsOrder_add_05 &&
            <Button style={{ marginLeft: 10 }} onClick={this.goView.bind(this, '/mianjiaprint/2')}>不含单价打印</Button>}*/}
                        {button_limits_end.thingsOrder_add_02 &&
                            <Button style={{
                                display: (hasData && (resultData[0].orderStatus == 1 || resultData[0].orderStatus == 4)) ? 'inline-block' : 'none',
                                marginLeft: 10
                            }} onClick={this.goView.bind(this, '/mianjiaprint/1')}>面价打印</Button>}
                        {button_limits_end.thingsOrder_add_03 &&
                            <Button style={{
                                display: (hasData && (resultData[0].orderStatus == 1 || resultData[0].orderStatus == 4)) ? 'inline-block' : 'none',
                                marginLeft: 10
                            }} onClick={this.goView.bind(this, '/receiptprint/1')}>收据打印</Button>}
                        {button_limits_end.thingsOrder_detail_log && <Button
                            style={{
                                marginLeft: 10,
                                display: (hasData && resultData[0].orderStatus == 0) ? 'inline-block' : 'none'
                            }}
                            type="primary"
                            onClick={this.showModal}>登记</Button>}
                        {button_limits_end.thingsOrder_detail_log && <Button
                            style={{
                                marginLeft: 10,
                                display: (hasData && noShip && resultData[0].orderStatus == 1) ? 'inline-block' : 'none'
                            }}
                            type="primary"
                            onClick={this.showModal2}>{titleButton}</Button>}
                        {button_limits_end.thingsOrder_detail_log && <Button
                            style={{
                                marginLeft: 10,
                                display: (hasData && noShip && resultData[0].orderStatus == 1) ? 'inline-block' : 'none'
                            }}
                            type="danger"
                            onClick={this.showModal3}>整单删除</Button>}

                        <Modal title="注意"
                               visible={confirmvisible}
                               onOk={this.register}
                               confirmLoading={confirmLoading}
                               onCancel={this.handleCancel3}
                        >
                            <p>{"登记后将无法修改、删除订单，确认提交订单？"}</p>
                        </Modal>

                        <Modal title="注意"
                               visible={confirmvisible2}
                               onOk={this.shipAll}
                               confirmLoading={confirmLoading2}
                               onCancel={this.handleCancel3}
                        >
                            <p>{"确定发运整单吗？"}</p>
                        </Modal>

                        <Modal title="注意"
                               visible={confirmvisible3}
                               onOk={this.delAll}
                               confirmLoading={confirmLoading3}
                               onCancel={this.handleCancel3}
                        >
                            <p>{"确定删除整单吗？"}</p>
                        </Modal>

                        {!!this.userData.second && button_limits_end.thingsOrder_detail_edit && hasData && (resultData[0].orderStatus == -1 || resultData[0].orderStatus == 2) &&
                            <Button onClick={this.edit.bind(this)} style={{marginLeft: 10}}>编辑</Button>}
                        {!this.userData.second && button_limits_end.thingsOrder_detail_edit && hasData && resultData[0].orderStatus == 0 &&
                            <Button onClick={this.edit.bind(this)} style={{marginLeft: 10}}>编辑</Button>}
                        <Button onClick={this.goBack} style={{marginLeft: 10}}>返回</Button>
                    </DmsTab>
                    <div className="dms-table-box">
                        <Tooltip><font
                            style={{color: 'red'}}>新增手动【出库】功能，即订单登记后，需要手动点击绿色的出库按钮。对此功能如有疑问，请电话联系天正-信息部-詹岳鹏：13695715310</font></Tooltip>
                        <DisplayForm dataSource={displayData} perRow="2"/>
                        <div>
                            <DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}/>
                            <div className="dms-table-box">
                                <TableView {...tableViewProps} />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    visible={visible}
                    onOk={() => {
                        this.handleOK()
                    }}
                    onCancel={() => {
                        this.handleCancel()
                    }}
                >
                    <DmsTab className="white-bg no-border" options={['选择打印方式']} defaultKey={0}/>
                    <Select
                        showSearch
                        value={defaultDistributor}
                        style={{width: 200}}
                        placeholder="请选择经销商公司"
                        optionFilterProp="children"
                        notFoundContent="无法找到"
                        onChange={(value) => {
                            this.handleChange(value)
                        }}
                    >
                        {
                            distributorList.map(item => <Select.Option value={item.id + ''}
                                                                       key={item.id}>{item.companyName}</Select.Option>)
                        }
                    </Select><br/><br/>
                    <RadioGroup onChange={this.printTypeChange} value={printType}>
                        <Radio value={1}>整单打印</Radio>
                        <Radio value={2}>发货时间打印</Radio>
                        <Radio value={3}>抬头打印</Radio>
                        <Radio value={4}>不含价格金额打印</Radio>
                    </RadioGroup><br/><br/>
                    <div style={printType == '2' ? {display: "block"} : {display: "none"}}>
                        <RangePicker
                            showTime={{format: 'HH:mm:ss'}}
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder={['开始时间', '结束时间']}
                            onChange={this.onChange}
                            onOk={this.onOk}
                            style={{width: '350px'}}
                        /></div>
                </Modal>
                <Modal
                    title="驳回订单"
                    visible={this.state.submitVisible}
                    onOk={this.returnFn}
                    onCancel={() => this.setState({submitVisible: false})}
                >
                    <div>
                        驳回原因：<Input value={this.state.rejectRemark}
                                        onChange={e => this.setState({rejectRemark: e.target.value})}></Input>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default withRouter(ThingsOrder);



// WEBPACK FOOTER //
// ./src/routes/thingsOrder/detail.js